import React from 'react';
import { Loading } from '../stories/Loading';

interface NotFoundProps {}

const NotFound = (props: NotFoundProps) => {
  return <Loading />;
};

export default NotFound;
